import React from 'react';
import { css, html, js, nodejs, react, scss } from './Images';
import { Item } from './Item';

export const Skills = () => {
  const stack = [
    { id: 0, src: js, language: 'JavaScript', level: 4 },
    { id: 1, src: html, language: 'HTML', level: 5 },
    { id: 2, src: css, language: 'CSS', level: 5 },
    { id: 3, src: scss, language: 'SCSS', level: 4 },
    { id: 4, src: react, language: 'React', level: 3 },
    { id: 5, src: nodejs, language: 'NodeJS', level: 1 },
  ];

  return (
    <div className="skills">
      <h1 className="section-h1">Technology Stack</h1>
      <div className="stack">
        {stack.map(el => {
          return <Item src={el.src} level={el.level} key={el.id} />;
        })}
      </div>
    </div>
  );
};
